/**
 * ProtectedRoute — bounces guests to `/login`. Renders the child route
 * otherwise. Waits for `useAuth()` to prime so the page doesn't flash before
 * the token check resolves on refresh.
 *
 * Portal gate: a parent who set a password through an onboarding link but
 * has not added a child yet (`onboarding_pending`) is sent to wizard Step 2
 * until at least one child exists.
 */

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { ROUTES } from "@/types/routes";

import { LaunchCurtain } from "./LaunchCurtain";

export function ProtectedRoute() {
  const { isReady } = useAuth();
  return (
    <LaunchCurtain ready={isReady}>
      <ProtectedGate />
    </LaunchCurtain>
  );
}

function ProtectedGate() {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  if (user?.role === "parent" && user.onboarding_pending) {
    return <Navigate to={ROUTES.ONBOARDING} replace />;
  }
  return <Outlet />;
}
